import { render, staticRenderFns } from "./share-catalog-link.vue?vue&type=template&id=73356a8a&scoped=true"
import script from "./share-catalog-link.vue?vue&type=script&lang=js"
export * from "./share-catalog-link.vue?vue&type=script&lang=js"
import style0 from "./share-catalog-link.vue?vue&type=style&index=0&id=73356a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73356a8a",
  null
  
)

export default component.exports